<script setup>
import { formatNumber } from "@/utils/helpers";
import { onMounted, computed } from "vue";

const props = defineProps({
    LoteStore: Object,
    confirmacionAlert: Object,
    prorrogaActivada: Boolean
});

function cerrarModal() {
    props.confirmacionAlert.hide();
}

const isProrrogaActiva = computed(() => props.prorrogaActivada);

onMounted(() => {
    const modalEl = document.getElementById("ofertaEnviadaModal");

    if (modalEl) {
        modalEl.addEventListener("shown.bs.modal", () => {
            setTimeout(() => {
                cerrarModal();
            }, 6000);
        });
    }
});
</script>

<template>
    <div class="modal fade" id="ofertaEnviadaModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content text-center p-5 position-relative">
                <!-- Botón de cierre -->
                <button type="button"
                    class="position-absolute top-0 end-0 m-2 me-2 bg-soft-grey border-0 rounded-circle d-flex align-items-center justify-content-center"
                    style="width: 40px; height: 40px;" @click="cerrarModal" aria-label="Close">
                    <span class="fs-global-iconos mb-1">&times;</span>
                </button>

                <div class="d-flex align-items-center justify-content-center mb-3 gap-2">
                    <div
                        class="icono-alerta rounded-circle bg-soft-green d-flex align-items-center justify-content-center"
                        >
                        <i class="fas fa-check text-soft-green fs-global-iconos"></i>
                    </div>

                    <h5 class="text-soft-green fw-bold fs-global-titulos mb-0">
                        ¡OFERTA ENVIADA!
                    </h5>
                </div>

                <div class="pe-2 ps-2" v-if="isProrrogaActiva">
                    <h6 class="fw-400 text-black fs-global-contenido text-md-start text-center">
                    Como ofertaste <span class="text-soft-green fw-500">2 minutos</span> antes del cierre, extendimos <span class="text-soft-green fw-500">5 minutos</span> la puja para que todos tengan las mismas posibilidades de ofertar.
                    </h6>
                </div>

                <!-- Precio -->
                <h2 class="text-soft-green fw-bold mt-2 mb-0">$ {{ formatNumber(props.LoteStore.panelOferta.nueva_oferta) }}
                </h2>
            </div>
        </div>
    </div>
</template>


<style scoped>
.modal-content {
    border-radius: 10px;
    border: none;
}
</style>